import { NavLink } from "react-router";

const Home = () => {
  return (
    <div>
      <h1>Welcome to the Home Page!</h1>

      <NavLink to="/add-one" end>
        Add 1
      </NavLink>
    </div>
  );
};

export default Home;
